module.exports = __webpack_public_path__ + "static/media/move-drag-icon.93781f41.svg";